const Title = ({ title }: { title: string }) => {
  return (
    <h2 className="section-title">
      <span className="hash">##</span>
      {title}
    </h2>
  );
};

export default Title;
